import * as Yup from 'yup';

const passwordResetRequestSchema = Yup.object({
  email: Yup.string()
    .label('Sähköpostiosoite')
    .email()
    .nullable()
    .required()
});

export default passwordResetRequestSchema;

export type PasswordResetRequestSchema = ReturnType<
  typeof passwordResetRequestSchema.cast
>;
